/**
 * BEPRO Shop - Account Module
 * Tab switching, profile/address/password AJAX forms, password reset
 */

export default function initAccount() {
	initTabs();
	initProfileForm();
	initAddressForm();
	initPasswordForm();
	initLostPasswordForm();
	initResetPasswordForm();
}

function initTabs() {
	const tabs = document.querySelectorAll('.my-account__tab');
	const panels = document.querySelectorAll('.my-account__panel');
	if (!tabs.length) return;

	tabs.forEach(tab => {
		tab.addEventListener('click', () => {
			tabs.forEach(t => t.classList.remove('is-active'));
			panels.forEach(p => p.classList.remove('is-active'));
			tab.classList.add('is-active');
			const panel = document.getElementById('tab-' + tab.dataset.tab);
			if (panel) panel.classList.add('is-active');
		});
	});
}

function ajaxForm(formSelector, messageSelector, action, nonceKey) {
	const form = document.querySelector(formSelector);
	if (!form) return;
	const config = window.beproAccount || {};

	form.addEventListener('submit', async (e) => {
		e.preventDefault();
		const msgEl = document.querySelector(messageSelector);
		const btn = form.querySelector('button[type="submit"]');
		btn.disabled = true;

		const formData = new FormData(form);
		formData.append('action', action);
		formData.append('nonce', config[nonceKey] || config.profileNonce || '');

		try {
			const res = await fetch(config.ajaxUrl, { method: 'POST', body: formData });
			const data = await res.json();

			if (msgEl) {
				msgEl.textContent = data.data?.message || (data.success ? 'Uspješno!' : 'Greška.');
				msgEl.className = messageSelector.replace('.', '') + (data.success ? ' success' : ' error');
				msgEl.style.display = 'block';
			}

			if (data.success && action === 'bepro_reset_password') {
				setTimeout(() => { window.location.href = window.location.pathname; }, 2000);
			}
		} catch (err) {
			if (msgEl) {
				msgEl.textContent = 'Greška. Pokušajte ponovo.';
				msgEl.className = messageSelector.replace('.', '') + ' error';
				msgEl.style.display = 'block';
			}
		}
		btn.disabled = false;
	});
}

function initProfileForm() {
	ajaxForm('.js-profile-form', '.js-profile-message', 'bepro_update_profile', 'profileNonce');
}

function initAddressForm() {
	ajaxForm('.js-address-form', '.js-address-message', 'bepro_save_address', 'profileNonce');
}

function initPasswordForm() {
	ajaxForm('.js-password-form', '.js-password-message', 'bepro_update_password', 'profileNonce');
}

function initLostPasswordForm() {
	ajaxForm('.js-lost-password-form', '.js-lost-password-message', 'bepro_lost_password', 'lostPasswordNonce');
}

function initResetPasswordForm() {
	ajaxForm('.js-reset-password-form', '.js-reset-password-message', 'bepro_reset_password', 'resetPasswordNonce');
}
